export const defaultSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Sociedade Beneficente Muçulmana do Rio de Janeiro',
  url: 'https://sbmrj.org.br',
  logo: 'https://sbmrj.org.br/assets/images/mosque/SBMRJ_Logo_Home_Large.png',
  description: 'Descrição da Mesquita',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rua Gonzaga Bastos, 77',
    addressLocality: 'Rio de Janeiro',
    addressRegion: 'RJ',
    postalCode: '20541-000',
    addressCountry: 'Brasil',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '(21) 2224-1079',
  },
  openingHours: 'Sex 12:00-14:00',
  sameAs: [
    'https://www.facebook.com/sbmrjmesquita',
    'https://www.instagram.com/sbmrjmesquita',
    'https://www.youtube.com/@sbmrj',
  ],
};
